var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "outer-container" },
    [
      _c(
        "div",
        { staticClass: "cropper-container", class: { mobile: _vm.isMobile } },
        [
          _c("cropper", {
            ref: "cropper",
            staticClass: "cropper",
            class: { mobile: _vm.isMobile },
            attrs: {
              src: _vm.img,
              "stencil-component": `${_vm.stencilType}-stencil`,
              "stencil-props": {
                handlers: {},
                movable: false,
                resizable: false,
                aspectRatio: _vm.aspectRatio,
                lines: { north: false, west: false, south: false, east: false }
              },
              stencilSize: _vm.stencilSize,
              foregroundClass: "vue-advanced-cropper-foreground",
              backgroundClass: "vue-advanced-cropper-background",
              "resize-image": { adjustStencil: false },
              "image-restriction": "stencil",
              transitions: false,
              debounce: false,
              "min-width": 100,
              "min-height": 100
            },
            on: { change: _vm.onChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showNavigation
        ? _c("Navigation", {
            attrs: { zoom: _vm.zoom },
            on: { change: _vm.onZoom }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }